import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";

export default {
    methods: {
        async getRepairPlaceList(filter) {
            var meta = { clientApiMethod: 'getRepairPlaceList', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "RepairPlace", { params: filter, meta: meta })
            return response?.data;
        },
        async getRepairPlace(id) {
            var meta = { clientApiMethod: 'getRepairPlace', input: { id: id } }
            var response = await client().get(store.state.apiRouteRoot + "RepairPlace/" + id, { meta: meta })
            return response?.data;
        },
        async createRepairPlace(newRepairPlace) {
            var meta = {
                clientApiMethod: 'createRepairPlace',
                input: { newRepairPlace },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.repair_place.repair_place") })
            }
            var response = await client().post(store.state.apiRouteRoot + 'RepairPlace', newRepairPlace, { meta: meta })
            return response?.data;
        },
        async changeRepairPlace(updatedRepairPlace) {
            var meta = {
                clientApiMethod: 'changeRepairPlace',
                input: { updatedRepairPlace },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.repair_place.repair_place") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'RepairPlace', updatedRepairPlace, { meta: meta })
            return response?.data;
        },
        async deleteRepairPlace(RepairPlaceId) {
            var meta = {
                clientApiMethod: 'deleteRepairPlace',
                input: { RepairPlaceId: RepairPlaceId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.repair_place.repair_place") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "RepairPlace/" + RepairPlaceId, { meta: meta })
            return response?.data;
        },
    }
}